import { useState } from "react";

const useModal = () => {
  const [showDialog, setShowDialog] = useState(false);

  const handleOpenClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  return {
    handleOpenClick,
    handleCloseClick,
    showDialog
  };
};

export default useModal;
